import React from "react";
import PropTypes from "prop-types";
import Theme from "../../App/Theme";

const appBarHeight = 64;
const appStatusBar = 0; //30;

class TAppContent extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        appSideBarWidth: PropTypes.number,
        sideBarVisible: PropTypes.bool,
        pageID: PropTypes.string.isRequired,
    };

    static defaultProps = {
        appSideBarWidth: 255,
        sideBarVisible: false,
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        let styles = {
            page: {
                transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)",
                height: "calc(100% - " + appBarHeight + "px - " + appStatusBar + "px)",
                overflowY: "auto",
                //marginLeft: (this.props.sideBarVisible) ? 256 : 0,
                position: "absolute",
                right: 0,
                left: this.props.sideBarVisible ? this.props.appSideBarWidth + 1 : 0,
                top: appBarHeight,
                background: Theme.content.background,
            },
            innerPage: {
                margin: 20,
            },
        };

        return (
            <div style={styles.page}>
                <div>{this.props.children ? this.props.children : <div>No children given</div>}</div>
            </div>
        );
    }
}

export default TAppContent;
